import { ProviderTemplate } from './types';

export const domainProviders: Record<string, ProviderTemplate> = {
  namecheap: {
    name: 'Namecheap DNS',
    icon: '🟣',
    description: 'Domain & Hosting',
    fields: [
      {
        key: 'api_user',
        label: 'API Username',
        type: 'text',
        required: true,
        help: 'Your Namecheap username',
      },
      {
        key: 'api_key',
        label: 'API Key',
        type: 'password',
        required: true,
        help: 'API key from your Namecheap account',
      },
      {
        key: 'username',
        label: 'Username',
        type: 'text',
        required: true,
        help: 'Username for API requests (usually same as API User)',
      },
      {
        key: 'client_ip',
        label: 'Client IP',
        type: 'text',
        required: true,
        help: 'Your public IP address (must be whitelisted)',
      },
    ],
    docsUrl: 'https://www.namecheap.com/support/api/intro/',
  },
  godaddy: {
    name: 'GoDaddy DNS',
    icon: '🟢',
    description: 'Domain Registration',
    fields: [
      {
        key: 'api_key',
        label: 'API Key',
        type: 'password',
        required: true,
        help: 'GoDaddy API key',
      },
      {
        key: 'api_secret',
        label: 'API Secret',
        type: 'password',
        required: true,
        help: 'GoDaddy API secret',
      },
      {
        key: 'environment',
        label: 'Environment',
        type: 'select',
        required: true,
        options: ['production', 'sandbox'],
        help: 'API environment (use sandbox for testing)',
      },
    ],
    docsUrl: 'https://developer.godaddy.com/',
  },
  dnsimple: {
    name: 'DNSimple',
    icon: '🔷',
    description: 'Simple DNS Management',
    fields: [
      {
        key: 'api_token',
        label: 'API Token',
        type: 'password',
        required: true,
        help: 'DNSimple API token from your account settings',
      },
      {
        key: 'account_id',
        label: 'Account ID',
        type: 'text',
        required: true,
        help: 'Your DNSimple account ID (found in account settings)',
      },
    ],
    docsUrl: 'https://dnsimple.com/api',
  },
};